import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCooneyBrothers/Handlers/CustomHandlerCreator";

type HandlerType = CustomHandler<{ cartFreightTermsSelected: boolean }>;

export const DispatchSetFreightTermsSelected: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/SetFreightTermsSelected",
        cartFreightTermsSelected: props.parameter.cartFreightTermsSelected,
    });
};

export const chain = [DispatchSetFreightTermsSelected];

const setFreightTermsSelected = createHandlerChainRunner(chain, "SetFreightTermsSelected");
export default setFreightTermsSelected;
